import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser, useRating } from "utils/hooks";
import { filtersToQueryParams, anyToHash } from "utils/misc";

export default function useVideos(filters = {}, options = { enabled: true }) {
  const { rating } = useRating();
  const { token } = useUser();

  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchVideos() {
      setLoading(true);

      const { response, data } = await API.fetchVideos(token, filtersToQueryParams({ rating, ...filters }));

      if (response.ok) {
        setResult(data);
        setLoading(false);
      }
    }

    if (options.enabled === true) {
      fetchVideos();
    }
  }, [options?.enabled, anyToHash({ ...filters, rating })]);

  return {
    loading,
    videos: result?.results ?? [],
    count: result?.count ?? 0,
    limit: result?.limit ?? 0,
    page: result?.page ?? 0,
  };
}
